<template>
    <Tabs v-if="tabs.length > 1" :active="activeTab" :tabs="tabs" :onChange="setActiveTab" />
    <Details v-if="activeTab === ProductModalTab.Details" :product="product" />
    <Price v-if="activeTab === ProductModalTab.Price" :product="product" />
    <Terms
        v-if="activeTab === ProductModalTab.Terms && product.FlightTermsUrl"
        :product="product" />
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import { ProductModalTab, ModalType } from '@/store/general/types';
    import { isNotNil } from '@shared/utils/value';
    import { TabButton } from '@ui/components/Tabs/Tabs.interfaces';
    import { useStore } from '@/store';
    import Tabs from '@ui/components/Tabs/Tabs.vue';
    import Details from './Details/Details.vue';
    import Price from './Price/Price.vue';
    import Terms from './Terms/Terms.vue';

    export default defineComponent({
        name: 'FlightModal',
        methods: { t },
        components: {
            Tabs,
            Details,
            Price,
            Terms,
        },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
            activeTab: {
                type: String as PropType<ProductModalTab>,
                default: ProductModalTab.Details,
            },
        },
        setup(props) {
            const store = useStore();

            const tabs = computed<TabButton[]>(() =>
                [
                    {
                        value: ProductModalTab.Details,
                        label: t({ key: 'shared.details' }),
                    },
                    props.product.FlightTermsUrl
                        ? {
                              value: ProductModalTab.Terms,
                              label: t({ key: 'shared.ticket_policy' }),
                          }
                        : null,
                    {
                        value: ProductModalTab.Price,
                        label: t({ key: 'shared.price' }),
                    },
                ].filter(isNotNil)
            );

            const setActiveTab = (tab: string) => {
                store.dispatch('general/setModal', {
                    type: ModalType.Product,
                    productId: props.product.Id,
                    activeTab: tab,
                });
            };

            return {
                tabs,
                setActiveTab,
                ProductModalTab,
            };
        },
    });
</script>
